import React from 'react'
import ResetPassword from '@components/auth/reset-password'
import { Container } from '@chakra-ui/react'
import MainLayout from '@layouts/main-layout'
import { NextPageWithLayout } from 'types/global'

const ResetPasswordPage: NextPageWithLayout = () => {
  return (
    <>
      <Container>
        <ResetPassword />
      </Container>
    </>
  )
}

ResetPasswordPage.getLayout = (page) => {
  return <MainLayout>{page}</MainLayout>
}

export default ResetPasswordPage
